export default [
  {
    path: '/addIccardTemplate', name: 'addIccardTemplate', component: () => import('@/pages/iccard/addIccardTemplate'), meta: { title: '新建' },
  },
  {
    path: '/iccardManage', name: 'iccardManage', component: () => import('@/pages/iccard/iccardManage'), meta: { title: '会员卡' },
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/iccard.js